<template>
    <div>
        <v-card class="mt-2">
            <v-card-title class="q_leads_1 align-start" style="font-size: 1rem" :id=" entity + '_datatable'">
                <v-col cols="12" sm="6">
                    <div class="white--text d-flex align-center">
                        <p class="q-display-3 mb-0" id="datatable">
                            {{ title }}
                        </p>
                        <v-btn dark icon @click="refresh">
                            <v-icon>fas fa-redo-alt</v-icon>
                        </v-btn>
                    </div>
                    <p class="pt-2 mb-0">
                        <v-btn class="pa-2" text small color="q_leads_4" @click="toggleFilters">
                            <v-icon small left>fas fa-filter</v-icon> Filters
                        </v-btn>
                    </p>
                </v-col>
                <v-col cols="12" sm="6">
                    <!-- Searchbar with issues -->
                    <!-- <v-text-field dense dark v-model="search" append-icon="icon-q-search" label="Search" single-line hide-details @keyup="maybeSearch" @click:append="refreshData" /> -->
                    <q-time-period-select :dark="true" v-model="time_filters" label="Time Period" :with-all="true" :allow-current="true" stateKey="stat"></q-time-period-select>
                </v-col>
            </v-card-title>
            <v-card-text v-show="$refs.filters && $refs.filters.show">
                <v-row class="d-flex justify-start">
                    <q-filters dark ref="filters" :hide-button="true" v-model="filters" :available-filters="available_filters" :keys="filter_keys">
                        <v-switch hide-details inset v-model="include_downlines" label="Include Downline"></v-switch>
                    </q-filters>
                </v-row>
            </v-card-text>
            <v-row class="mx-4 my-2">
                <v-col cols="12" class="d-flex justify-end">
                    <v-btn text small color="q_leads_4" @click="exportResults">
                        <v-icon small left>fas fa-file-export</v-icon> Export Results
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table v-on:current-items="updateCurrentItems" :mobile-breakpoint="2" :items-per-page.sync="rows" :search="search" :headers="the_headers" :items="calc_data" item-key="$id" class="elevation-0 pointer" :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }" :loading="is_loading">
                <template v-slot:item.CreateDate="{ item }">
                    {{ formatDate(item.CreateDate) }}
                </template>
                <template v-slot:item.AgentName="{ item }">
                    <a @click.stop.prevent="viewAgent(item.AgentCode)">{{item.AgentName}}</a>
                </template>
                <template v-slot:item.CloseRatio="{ item }">
                    <span>{{ formatPercentage(item.CloseRatio) }}</span>
                </template>
                <template v-slot:item.ApprovedCloseRatio="{ item }">
                    <span>{{ formatPercentage(item.ApprovedCloseRatio) }}</span>
                </template>
                <template v-slot:body.append>
                    <tr>
                        <th class="title text-right">Totals</th>
                        <th class="title text-center">{{ sumField("NumLeads") }}</th>
                        <th class="title text-center">{{ sumField("NumApps") }}</th>
                        <th class="title text-center">{{ sumField("NumAppsEnrolled") }}</th>
                        <th class="title text-center">{{ sumField("NumApprovedApps") }}</th>
                        <th class="title text-center">{{ formatPercentage( sumField("NumApps") / sumField("NumLeads") )}}</th>
                        <th class="title text-center">{{ formatPercentage( sumField("NumApprovedApps") / sumField("NumLeads") )}}</th>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        
    </div>
</template>
<script>
import QDataTableMixin from "../QDataTableMixin";
import QuilityAPI from "@/store/API/QuilityAPI.js";
import { debounce } from "vue-debounce";
import QDataTableHeader from "../base/QDataTableHeader.vue";
import QTimePeriodSelect from '@/components/utils/QBusinessTimePeriodSelect.vue';
import moment from 'moment';

export default {
    name: "QCloseRatioDataTable",
    mixins: [QDataTableMixin],
    props: ["agent"],
    data: function() {
        // data internal to component (not available outside)
        return {
            entity: "closeratio",
            //use this to "preset" a filter
            filters: {},
            time_filters : {},
            firstPull: true, // this keeps the auto scrolling on data reloads from happening on the first load.
            the_data: [],
            options: { sortBy: ["CloseRatio"], sortDesc: ["true"] },
            status_items: [],
            saving: false,
            is_exporting: false,
            warning: null,
            error: null,
            include_downlines : false,
            datePeriod: { label: 'Current Month', 'period': 'month' },
            is_loading : false
        };
    },
    mounted: function() {
    },
    computed: {
        filter_keys: function() {
            return [];
        },
        all_data: function() {
            return this.the_data;
        },
        calc_data: function() {
            var d = this.the_data
            this.the_data.forEach((i, ix) => {
                if(i.NumApps > 0){
                    d[ix].CloseRatio = i.NumApps / i.NumLeads;
                }else{
                    d[ix].CloseRatio = 0;
                }
                
                if (i.NumApprovedApps > 0){
                    d[ix].ApprovedCloseRatio = i.NumApprovedApps / i.NumLeads;
                }else{
                    d[ix].ApprovedCloseRatio = 0;
                }
                
            })
            return d;
        },
        the_headers() {
            return [
                    {
                        text: "Agent",
                        value: "AgentName",
                        align: "start",
                        sortable: true,
                        filterable: true,
                        class: "header-class",
                    },
                    {
                        text: "Leads",
                        value: "NumLeads",
                        align: "center",
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "Apps",
                        value: "NumApps",
                        align: "center",
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "Enrolled",
                        value: "NumAppsEnrolled",
                        align: "center",
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "Approved Apps",
                        value: "NumApprovedApps",
                        align: "center",
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "Close Ratio",
                        value: "CloseRatio",
                        align: "center",
                        align: "center",
                    },
                    {
                        text: "Approved Close Ratio",
                        value: "ApprovedCloseRatio",
                        align: "center",
                        align: "center",
                    },
                ];
        },
        available_filters : function(){
            return [];
        }
    },
    methods: {
        loadData: debounce(function(opt) {
            const g = this;
            let getAgentCode = ''
            var f = {
                ...g.filters,
                startDate : g.time_filters.startDate,
                endDate : g.time_filters.endDate,
            }
			g.agentCode ? getAgentCode = g.agentCode : getAgentCode = g.user.Agent.AgentCode
            
            if (this.hasRole(['AgencyOwner'])){
                var f = QuilityAPI.getBaseshopCloseRatioStats(this.user.AgentCode, f)
            } else if (this.hasRole(['Staff', 'SuperAdmin'])){
                f = QuilityAPI.getTenantCloseRatioStats(this.current_tenant.ID, f)
            }else{
                f = QuilityAPI.getAgentCloseRatioStats(getAgentCode, f)
            }       
            g.is_loading = true
            f.then(function(results) {
                    g.is_loading = false
                    var ar = [];
                    if (typeof results.data != "undefined") {
                        if (Array.isArray(results.data)) {
                            g.the_data = results.data;
                        }else{
                            g.the_data = [results.data];
                        }
                    } else {
                        g.showError("Whoops! " + results.message);
                    }
                })
                .catch(function(err) {
                    g.is_loading = false
                    console.log(err);
                    if (err.status == 431) {
                        g.showError(err + " You probably need to clear all your cookie and session variables and login again.");
                        return;
                    }
                    //g.showError(err.status)
                });
            g.firstPull = false;
        }, 200),
        refresh: function() {
            const g = this;
            g.the_data = [];
            g.refreshData();
        },
        exportResults: function() {
            // all data is loaded, so no need to request from the server again
            this.downloadCsv(this.the_data)
        },
        downloadCsv: function(data) {
            const lines = []
            
            let headers = this.the_headers
            let agent_code = { text: 'Agent Code', value: 'AgentCode' }
            headers.splice(1, 0, agent_code)
            
            //array of data table fields for csv header row
            const fields = headers.map(header => {
                return header.text
            })
            //build the string and add to lines array
            lines.push(`"`+fields.join(`","`)+`"`)
            //loop through records and build the csv text line
            data.map(application => {
                //array of field values based on fields defined by data table
                let values = headers.map(header => {
                    switch (header.value) {
                        case 'ApprovedCloseRatio':
                        case 'CloseRatio':
                            return this.formatPercentage(application[header.value])
                        default:
                            return application[header.value]
                    }
                })
                //build the string and add to lines array
                lines.push(`"`+values.join(`","`)+`"`)
            })

            //build all rows of csv by joining lines array
            let txt = lines.join("\n")

            //generate the download
            var element = document.createElement('a')
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(txt))
            element.setAttribute('download', "CloseRatios.csv")
            element.style.display = 'none'
            document.body.appendChild(element)
            element.click()
            document.body.removeChild(element)

        },
        goToTop: function() {
            this.$vuetify.goTo("#" + this.entity + "_datatable", {
                duration: 500,
                easing: "easeOutCubic",
                offset: 300,
            });
        },
        viewAgent(agentCode){
            this.$router.push({ name: 'AgentDetail', params: { agentcode: agentCode} })
        },
        sumField(key) {
            return this.the_data.reduce((a, b) => a + (b[key] || 0), 0)
        }
    },
    watch: {
        time_filters : function(){
            this.$nextTick(this.refreshData);
        },
        'current_tenant.ID' : function(){
            this.$nextTick(this.refreshData);
        },
    },
    components: {
        QDataTableHeader,
        QTimePeriodSelect,
    },
};
</script>
<style scoped>
.nowrap {
    white-space: nowrap;
}

.table-cursor tbody tr:hover {
    cursor: pointer;
}
</style>